/**
 * Mock agreement data for the Agreement Review page.
 * Replace with real API calls when the backend /agreements endpoint is ready.
 */

const MOCK_AGREEMENTS = [
  /* Sample data cleared — fresh agreements created via Upload modal */
];

// eslint-disable-next-line no-unused-vars
const _SAMPLE_DATA_BACKUP = [
  // --- DRAFT ---
  {
    id: 'agr-001',
    type: 'NDA',
    status: 'DRAFT',
    counterpartyName: 'Nightwing',
    counterpartyShortName: 'NW',
    opportunityOwner: 'Chris Blahm',
    opportunityName: 'Shake and Bake',
    termDuration: '3 years',
    termsType: 'standard',
    signedDate: null,
    expirationDate: null,
    createdAt: '2026-03-18T10:00:00Z',
    updatedAt: '2026-03-18T10:00:00Z',
    createdBy: 'chris.blahm@bcore.com',
    notes: '',
  },
  {
    id: 'agr-002',
    type: 'NDA',
    status: 'DRAFT',
    counterpartyName: 'Peraton',
    counterpartyShortName: 'PRT',
    opportunityOwner: 'Chris Blahm',
    opportunityName: 'Overwatch',
    termDuration: '5 years',
    termsType: 'standard',
    signedDate: null,
    expirationDate: null,
    createdAt: '2026-03-15T14:30:00Z',
    updatedAt: '2026-03-16T09:00:00Z',
    createdBy: 'chris.blahm@bcore.com',
    notes: '',
  },
  {
    id: 'agr-003',
    type: 'TA',
    status: 'DRAFT',
    counterpartyName: 'SAIC',
    counterpartyShortName: 'SAIC',
    opportunityOwner: 'Matt Weinstein',
    opportunityName: 'ATLAS III',
    termDuration: '5 years',
    termsType: 'standard',
    signedDate: null,
    expirationDate: null,
    createdAt: '2026-03-20T08:15:00Z',
    updatedAt: '2026-03-20T08:15:00Z',
    createdBy: 'matt.weinstein@bcore.com',
    notes: '',
  },

  // --- PENDING_REVIEW ---
  {
    id: 'agr-004',
    type: 'NDA',
    status: 'PENDING_REVIEW',
    counterpartyName: 'Booz Allen Hamilton',
    counterpartyShortName: 'BAH',
    opportunityOwner: 'Chris Blahm',
    opportunityName: 'Sentinel',
    termDuration: '3 years',
    termsType: 'standard',
    signedDate: null,
    expirationDate: null,
    createdAt: '2026-03-10T11:00:00Z',
    updatedAt: '2026-03-14T16:00:00Z',
    createdBy: 'chris.blahm@bcore.com',
    notes: 'Counterparty signed, ready for B/CORE counter-signature.',
  },
  {
    id: 'agr-005',
    type: 'TA',
    status: 'PENDING_REVIEW',
    counterpartyName: 'Leidos',
    counterpartyShortName: 'LDOS',
    opportunityOwner: 'Matt Weinstein',
    opportunityName: 'FORGE',
    termDuration: '5 years',
    termsType: 'standard',
    signedDate: null,
    expirationDate: null,
    createdAt: '2026-03-08T09:30:00Z',
    updatedAt: '2026-03-12T14:00:00Z',
    createdBy: 'matt.weinstein@bcore.com',
    notes: 'Received from Leidos, needs internal review.',
  },
  {
    id: 'agr-006',
    type: 'TA',
    status: 'PENDING_REVIEW',
    counterpartyName: 'CACI',
    counterpartyShortName: 'CACI',
    opportunityOwner: 'Chris Blahm',
    opportunityName: 'Vanguard',
    termDuration: '3 years',
    termsType: 'standard',
    signedDate: null,
    expirationDate: null,
    createdAt: '2026-03-05T13:00:00Z',
    updatedAt: '2026-03-11T10:00:00Z',
    createdBy: 'chris.blahm@bcore.com',
    notes: '',
  },

  // --- NEEDS_CONTRACTS_REVIEW ---
  {
    id: 'agr-007',
    type: 'NDA',
    status: 'NEEDS_CONTRACTS_REVIEW',
    counterpartyName: 'ManTech',
    counterpartyShortName: 'MANT',
    opportunityOwner: 'Matt Weinstein',
    opportunityName: 'Iron Gate',
    termDuration: '5 years',
    termsType: 'non-standard',
    signedDate: null,
    expirationDate: null,
    createdAt: '2026-03-06T10:00:00Z',
    updatedAt: '2026-03-13T11:30:00Z',
    createdBy: 'matt.weinstein@bcore.com',
    notes: 'Counterparty redlined exclusivity clause. Needs LeNaye review.',
  },
  {
    id: 'agr-008',
    type: 'TA',
    status: 'NEEDS_CONTRACTS_REVIEW',
    counterpartyName: 'Parsons',
    counterpartyShortName: 'PSN',
    opportunityOwner: 'Chris Blahm',
    opportunityName: 'Pathfinder',
    termDuration: '3 years',
    termsType: 'non-standard',
    signedDate: null,
    expirationDate: null,
    createdAt: '2026-02-28T09:00:00Z',
    updatedAt: '2026-03-10T15:00:00Z',
    createdBy: 'chris.blahm@bcore.com',
    notes: 'Non-standard termination clause. Escalated to contracts.',
  },

  // --- FULLY_EXECUTED ---
  {
    id: 'agr-009',
    type: 'NDA',
    status: 'FULLY_EXECUTED',
    counterpartyName: 'Northrop Grumman',
    counterpartyShortName: 'NOC',
    opportunityOwner: 'Chris Blahm',
    opportunityName: 'Guardian',
    termDuration: '3 years',
    termsType: 'standard',
    signedDate: '2026-02-20T12:00:00Z',
    expirationDate: '2029-02-20T12:00:00Z',
    createdAt: '2026-02-10T08:00:00Z',
    updatedAt: '2026-02-20T12:00:00Z',
    createdBy: 'chris.blahm@bcore.com',
    notes: '',
  },
  {
    id: 'agr-010',
    type: 'NDA',
    status: 'FULLY_EXECUTED',
    counterpartyName: 'Raytheon',
    counterpartyShortName: 'RTX',
    opportunityOwner: 'Matt Weinstein',
    opportunityName: 'Aegis Next',
    termDuration: '5 years',
    termsType: 'standard',
    signedDate: '2026-01-15T10:00:00Z',
    expirationDate: '2031-01-15T10:00:00Z',
    createdAt: '2026-01-05T09:00:00Z',
    updatedAt: '2026-01-15T10:00:00Z',
    createdBy: 'matt.weinstein@bcore.com',
    notes: '',
  },
  {
    id: 'agr-011',
    type: 'TA',
    status: 'FULLY_EXECUTED',
    counterpartyName: 'CACI',
    counterpartyShortName: 'CACI',
    opportunityOwner: 'Chris Blahm',
    opportunityName: 'Crossbow',
    termDuration: '3 years',
    termsType: 'standard',
    signedDate: '2026-02-01T14:00:00Z',
    expirationDate: '2029-02-01T14:00:00Z',
    createdAt: '2026-01-20T11:00:00Z',
    updatedAt: '2026-02-01T14:00:00Z',
    createdBy: 'chris.blahm@bcore.com',
    notes: '',
  },
  {
    id: 'agr-012',
    type: 'TA',
    status: 'FULLY_EXECUTED',
    counterpartyName: 'Leidos',
    counterpartyShortName: 'LDOS',
    opportunityOwner: 'Matt Weinstein',
    opportunityName: 'Prism',
    termDuration: '5 years',
    termsType: 'non-standard',
    signedDate: '2025-12-10T16:00:00Z',
    expirationDate: '2030-12-10T16:00:00Z',
    createdAt: '2025-11-15T10:00:00Z',
    updatedAt: '2025-12-10T16:00:00Z',
    createdBy: 'matt.weinstein@bcore.com',
    notes: 'Non-standard revenue allocation terms negotiated.',
  },

  // --- EXPIRED ---
  {
    id: 'agr-013',
    type: 'NDA',
    status: 'EXPIRED',
    counterpartyName: 'BAE Systems',
    counterpartyShortName: 'BA',
    opportunityOwner: 'Chris Blahm',
    opportunityName: 'Horizon',
    termDuration: '2 years',
    termsType: 'standard',
    signedDate: '2023-06-15T12:00:00Z',
    expirationDate: '2025-06-15T12:00:00Z',
    createdAt: '2023-06-01T08:00:00Z',
    updatedAt: '2025-06-15T12:00:00Z',
    createdBy: 'chris.blahm@bcore.com',
    notes: '',
  },
  {
    id: 'agr-014',
    type: 'TA',
    status: 'EXPIRED',
    counterpartyName: 'General Dynamics',
    counterpartyShortName: 'GD',
    opportunityOwner: 'Matt Weinstein',
    opportunityName: 'Bastion',
    termDuration: '3 years',
    termsType: 'standard',
    signedDate: '2022-09-01T10:00:00Z',
    expirationDate: '2025-09-01T10:00:00Z',
    createdAt: '2022-08-15T09:00:00Z',
    updatedAt: '2025-09-01T10:00:00Z',
    createdBy: 'matt.weinstein@bcore.com',
    notes: '',
  },
];

/** Count of agreements needing review (for sidebar badge). */
const AGREEMENT_REVIEW_COUNT = MOCK_AGREEMENTS.filter(
  (a) => a.status === 'PENDING_REVIEW' || a.status === 'NEEDS_CONTRACTS_REVIEW'
).length;

/** Default form values for the upload modal. */
const EMPTY_AGREEMENT = {
  type: '',
  status: '',
  counterpartyName: '',
  counterpartyShortName: '',
  opportunityName: '',
  opportunityOwner: '',
  termsType: '',
  termDuration: '',
  notes: '',
};

export { MOCK_AGREEMENTS, AGREEMENT_REVIEW_COUNT, EMPTY_AGREEMENT };
